import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {
    MantineDataTable,
    SimpleTableBatchAction,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import {useTagsSelection} from '../hooks/useTagsSelection.ts';
import {useTags} from "../hooks/useTags.ts";
import {useTagsSearch} from "../hooks/useTagsSearch.ts";
import {useTagsPaging} from "../hooks/useTagsPaging.ts";
import {useAuth} from "../../../hooks/useAuth.ts";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {useTagsTableColumns} from "../hooks/useTagsTableColumns.tsx";
import {Tag} from "../types.ts";
import {DataTableColumn} from "mantine-datatable";
import {addToSelection} from '../reducers';
import {useAppDispatch} from '../../../hooks/useTypedReactRedux';


export const RecordsTable = (
    {
        extraTools,
        settings,
    }: {
        extraTools?: ReactElement[],
        settings?: { label: string, onClick: () => void }[]
    }) => {

    const dispatch = useAppDispatch();

    const {
        user
    } = useAuth();


    if (!user) {
        throw new Error('user is required parameter')
    }


    const {allowedActions} = useVerifiedPermissions()

    const {
        visibleItems,
        loading,
        visibleCount,
        nextToken,
        fetchRecords,
        isFetchingNextPage,
    } = useTags();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {
        columns,
    } = useTagsTableColumns();

    const {
        handleFilterByKeyword,
    } = useTagsSearch();

    const {
        limit,
        handleItemsPerPageChange,
    } = useTagsPaging();


    const {
        selection,
        handleClearSelection,
    } = useTagsSelection();


    let selectedRecords = undefined;
    if (allowedActions.includes(rbacActions.DeleteTag)) {
        selectedRecords = Object.keys(selection)
                                .map(key => selection[key])
    }

    return (
        <Stack gap={'lg'}>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={handleItemsPerPageChange}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={visibleItems}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach(item => {
                        dispatch(addToSelection(item as unknown as Tag));
                    })
                }}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination
                loadedCount={visibleCount}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
                isFetchingMore={isFetchingNextPage}
            />

        </Stack>
    );
};
